import { Navigate } from 'react-router-dom';

import useStateHandler from "@/hooks/useStateHandler";

import OnBoardingLayout from './components/OnBoardingLayout';

import './index.scss';

export default function OnBoarding({ user_type }) {

  const { state } = useStateHandler();

  if(user_type !== state.user_session.user_type) {
    return <Navigate to={`/onboarding/${state.user_session.user_type}`} replace/>;
  }

  return (
    <>
      <div className={`onboarding__container loading-completed`}>
        <OnBoardingLayout user_type={user_type}/>
      </div>
    </>
  );
}
